// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getCprWeekly(projectId: string, startDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/cpr_table?start_date=${startDate}`);
}
